// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --box-shadow: none;
}

ion-toolbar {
  --min-height: 56px;
}

ion-title {
  padding-left: 12px;
  padding-right: 12px;
  text-align: left;
}

.icon-toolbar {
  display: inline-block;
  vertical-align: middle;
}

.text-toolbar {
  vertical-align: middle;
  margin-left: 5px;
  font-size: 20px;
}

.text-introduction {
  font-size: 13px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  width: 100%;
  display: block;
}

ion-toggle {
  padding-right: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/options-version/options-version.component.scss","webpack://./src/components/general%20components/options-version/options-version.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;ACCJ;;ADEE;EACE,kBAAA;ACCJ;;ADEE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;ACCJ;;ADEE;EACE,qBAAA;EACA,sBAAA;ACCJ;;ADEE;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;ACCJ;;ADEE;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;ACCJ;;ADEE;EACE,2BAAA;ACCJ","sourcesContent":["ion-button {\n    --box-shadow: none;\n  }\n  \n  ion-toolbar {\n    --min-height: 56px;\n  }\n  \n  ion-title {\n    padding-left: 12px;\n    padding-right: 12px;\n    text-align: left;\n  }\n  \n  .icon-toolbar {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  \n  .text-toolbar {\n    vertical-align: middle;\n    margin-left: 5px;\n    font-size: 20px;\n  }\n  \n  .text-introduction {\n    font-size: 13px;\n    margin-top: 8px;\n    padding-left: 12px;\n    padding-right: 12px;\n    width: 100%;\n    display: block;\n  }\n  \n  ion-toggle {\n    padding-right: 0!important;\n  }\n  ","ion-button {\n  --box-shadow: none;\n}\n\nion-toolbar {\n  --min-height: 56px;\n}\n\nion-title {\n  padding-left: 12px;\n  padding-right: 12px;\n  text-align: left;\n}\n\n.icon-toolbar {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.text-toolbar {\n  vertical-align: middle;\n  margin-left: 5px;\n  font-size: 20px;\n}\n\n.text-introduction {\n  font-size: 13px;\n  margin-top: 8px;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: 100%;\n  display: block;\n}\n\nion-toggle {\n  padding-right: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
